


//NOT USED - FIGURE OUT HOW TO GET THIS TO WORK IN CONJUNCTION WITH REQUIRE_AUTH

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withRouter, Redirect } from 'react-router-dom';

import { currentUserRole } from '../util';

class RequireAdmin extends Component{

  render(){

    const authenticated = this.props.authenticated;
    const authenticating = this.props.authenticating;

    if(!authenticating && authenticated && currentUserRole() !== 'admin'){

      return (
        <Redirect to={{
            pathname: '/',
          }} />
      )
    }
    else if(authenticating){
      return (
        <div className="page loading">
          <h1>Authenticating...</h1>
        </div>
      );
    }
    else{
      return this.props.children;
    }
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    authenticating: state.user === 'authenticating',
    authenticated: (state.user && state.user.uid) ? true : false
  }
}

export default connect(mapStateToProps, {})(RequireAdmin);



// WEBPACK FOOTER //
// ./src/routes/requireAdmin.js